// import httpUtil from "../assets/script/utils/http";

const state = {
  wycContent: "",
  wycAbstract: "",
  edAbstract: "",
  sendCount: 0,
  showMsg: "",
  getSentenceTxt: "",
  getTitle: "",
  isShow: false,
  toKen:
    "5EC4B5B9290534596776ACC80F675576EF16159A013FCFA66B354FC83D716ADF0E3562D43533473F",
  openNewWycNum: 0
};

const mutations = {
  setIsShow(state, isShow) {
    state.isShow = isShow;
  },
  setopenWycNum(state, val) {
    state.openNewWycNum = state.openNewWycNum + val;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
